import { ReactElement, useState } from 'react';
import { Box, ClickAwayListener, Tooltip } from '@mui/material';

export function AiAvailabilityTooltip({
  reason,
  children,
}: {
  reason: string;
  children: ReactElement;
}) {
  const [open, setOpen] = useState(false);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={reason}
        open={Boolean(reason) && open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableTouchListener
        describeChild
      >
        <Box
          component="span"
          sx={{ display: 'inline-flex' }}
          tabIndex={reason ? 0 : undefined}
          aria-label={reason ? 'Why AI is unavailable' : undefined}
          onClick={() => {
            if (reason) setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') setOpen(false);
          }}
        >
          {children}
        </Box>
      </Tooltip>
    </ClickAwayListener>
  );
}
